import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Typography from '@mui/material/Typography';

const styles = {
  paddingLeft: '15px',
  paddingRight: '15px',
  borderRadius: '6px',
  background: 'white',
  marginBottom: '18px',
  marginLeft: '30px',
  marginRight: '30px',
};

const CourseStateComponent = ({ isActive }) => (
  <Typography style={styles} variant="caption" color="primary">
    <FormattedMessage
      id={isActive ? 'course.state.isActive' : 'course.state.isClosed'}
    />
  </Typography>
);

CourseStateComponent.propTypes = {
  isActive: PropTypes.bool,
};

CourseStateComponent.defaultProps = {
  isActive: false,
};

export default CourseStateComponent;
